import methods from '@/enums/methods';
import ThothV2 from '../base/thothV2';

class ConciliationEdiRedeService extends ThothV2 {

  refetchConciliation({ initialDate, finalDate }) {
    return this.fetch({
      url: '/edi-rede/reconciliate',
      method: methods.POST,
      data: {
        startDate: initialDate,
        endDate: finalDate,
      },
    });
  }

  getInfo({ initialDate, finalDate }) {
    return this.fetch({
      url: '/conciliation-soulpay/values',
      method: methods.GET,
      params: {
        startDate: initialDate,
        endDate: finalDate,
      },
    });
  }

  sendAllConciliations({ initialDate, finalDate }) {
    return this.fetch({
      url: '/files-conciliation/',
      method: methods.POST,
      data: {
        initialDate,
        finalDate,
      },
    });
  }
}

export default new ConciliationEdiRedeService();